export interface BarracksLevelDefinition {
  readonly level: number;
  readonly rosterCapacity: number;
  readonly externalCapacity: number;
  readonly mobilizationPresets: number;
}

/** Canonical Barracks capacities, kept as rows to keep progression aligned. */
export const BARRACKS_LEVELS = [
  { level: 1, rosterCapacity: 10, externalCapacity: 5, mobilizationPresets: 0 },
  { level: 2, rosterCapacity: 13, externalCapacity: 6, mobilizationPresets: 0 },
  { level: 3, rosterCapacity: 16, externalCapacity: 7, mobilizationPresets: 0 },
  { level: 4, rosterCapacity: 20, externalCapacity: 8, mobilizationPresets: 0 },
  { level: 5, rosterCapacity: 24, externalCapacity: 9, mobilizationPresets: 0 },
  { level: 6, rosterCapacity: 28, externalCapacity: 10, mobilizationPresets: 0 },
  { level: 7, rosterCapacity: 31, externalCapacity: 10, mobilizationPresets: 1 },
  { level: 8, rosterCapacity: 34, externalCapacity: 10, mobilizationPresets: 2 },
  { level: 9, rosterCapacity: 37, externalCapacity: 10, mobilizationPresets: 3 },
  { level: 10, rosterCapacity: 40, externalCapacity: 10, mobilizationPresets: 4 },
] as const satisfies readonly BarracksLevelDefinition[];

export const BARRACKS_MAX_LEVEL = BARRACKS_LEVELS.at(-1)!.level;

/** MVP starts maxed so every configured building benefit can be exercised. */
export const BARRACKS_MVP_INITIAL_LEVEL = BARRACKS_MAX_LEVEL;

export function barracksLevelDefinition(level: number): BarracksLevelDefinition {
  if (!Number.isInteger(level) || level < 1 || level > BARRACKS_MAX_LEVEL)
    throw new RangeError(
      `barracksLevel must be an integer from 1 to ${BARRACKS_MAX_LEVEL}`,
    );
  return BARRACKS_LEVELS[level - 1]!;
}

export function canDismissNinja(input: {
  foundationRemaining: number;
  rosterCount: number;
  lifeStatus: string;
  activityLock: string | null;
}): boolean {
  return (
    input.foundationRemaining === 0 &&
    input.rosterCount > 1 &&
    input.lifeStatus === "available" &&
    input.activityLock === null
  );
}
